export function formatDate(input: string): string {
    return new Date(input).toLocaleString('en-us', { day: 'numeric', month: 'short', year: 'numeric' });
}
